module.exports = __webpack_public_path__ + "static/media/figueira-2.926ac49e.jpg";